import { NgModule } from '@angular/core';
import { AfBrandLogoDirective } from './af-brand-logo.directive';

@NgModule({
  declarations: [
    AfBrandLogoDirective
  ],
  exports: [AfBrandLogoDirective]
})
export class AfDirectiveModule { }